<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
    :content-class="`changePassword ${type == 'member' ? 'member' : 'seller'}`"
  >
    <v-card class="px-12 py-8 text-caption">
      <v-form ref="form">
        <v-btn small icon absolute right top @click="dialog = false">
          <v-icon small icon>fa-times</v-icon>
        </v-btn>
        <v-card-title class="justify-center font-weight-bold mb-2">變更密碼</v-card-title>
        <span>舊密碼</span>
        <v-text-field 
          outlined 
          dense 
          background-color="white" 
          type="password" 
          :rules="[$rules.notEmpty]" 
          v-model="oldPassword"
          autofocus
        ></v-text-field>
        <span>新密碼</span>
        <v-tooltip bottom nudge-right="100">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-2 mb-1" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
          </template>
          <span>密碼長度須為 6 到 15 個字元，且包含英文字母及數字</span>
        </v-tooltip>
        <v-text-field 
          outlined 
          dense 
          background-color="white" 
          type="password" 
          :rules="[$rules.notEmpty]" 
          v-model="newPassword">
        </v-text-field>
        <span>確認新密碼</span>
        <v-text-field 
          outlined 
          dense 
          background-color="white" 
          type="password" 
          :rules="[rules.equalNewPassword]" 
          v-model="re_newPassword"
          @keydown.enter="changePassword"
        ></v-text-field>
        <v-btn color="pink" dark block rounded class="mt-2" @click="changePassword">送出</v-btn>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      oldPassword: '',
      newPassword: '',
      re_newPassword: '',
      rules: {
        equalNewPassword: value => value == this.newPassword
      },
      type: ''
    }
  },
  watch: {
    dialog(newValue, url) {
      if(!newValue) {
        this.$refs.form.reset()
      }
    }
  },
  computed: {
    formIsValid() {
      return (
        this.$rules.notEmpty(this.oldPassword) && 
        this.$rules.notEmpty(this.newPassword) && 
        this.rules.equalNewPassword(this.re_newPassword)
      )
    }
  },
  methods: {
    open(type) {
      this.dialog = true
      this.type = type
    },
    changePassword() {
      if(!this.formIsValid) {
        return
      }
      let url = this.type == 'member' ? '/member/password' : '/portal/password'
      this.axios.put(url,{
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      }).then(response => {
        this.$root.$emit('alert', 'success', '更新成功')
        this.dialog = false
      }).catch(e => {
        if(e.response.data.message == 'The old password is wrong.') {
          this.$root.$emit('alert', 'error', '舊密碼不正確')
        }
        else {
          this.$root.$emit('alert', 'error', '更新失敗')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.changePassword {
  &.member {
    i {
      color: white !important;
    }
    .v-card {
      background-color: $grey-2;
      color: white;
    }
  }
  &.seller {
    i {
      color: $grey-3 !important;
    }
    .v-card {
      color: $grey-3 !important;
    }
  }
}
</style>